import { Launch } from "@models/launch.model.ts";
import { httpRequest } from "../../http.ts";
import { LaunchSerializer } from "@models/serializers/launchSerializer.ts";

export class CommandCreateEngagementLaunch {
  async run(
    engagementId: number,
    name: string,
    objectiveId?: number,
    populationSegmentId?: number | null,
    populationSegmentExplicitNone = false,
  ) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/${engagementId}/launches/`;

    const body: any = {
      name: name
    };

    if (objectiveId) {
      body.objective_id = objectiveId;
    }

    if (populationSegmentId) {
      body.population_segment_id = populationSegmentId;
    }

    if (populationSegmentExplicitNone) {
      body.population_segment_explicit_none = true;
    }

    try {
      const response = await httpRequest<any>(url, {
        method: "POST",
        body: body
      });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error creating launch:", error);
      throw error;
    }
  }

  deserialize(data: any): Launch {
    return new LaunchSerializer().deserialize(data);
  }
}